module.exports = "/assets/data/cb86ef50d889bd18d1eb701f672065cc-L34.data.json";